export const traceAction = {
    created: 1,
    transferred: 2,
    frozen: 3,
    burnt: 4,
    lotDestroyed: 5,
    thawed: 6,
    reboxed: 7,
}

export const getTraceName = (actionId) => {
    switch (actionId) {
        case traceAction.created: return 'Created';
        case traceAction.transferred: return 'Transferred';
        case traceAction.frozen: return 'Frozen';
        case traceAction.burnt: return 'Burnt';
        case traceAction.lotDestroyed: return 'Destroyed';
        case traceAction.thawed: return 'Thawed';
        case traceAction.reboxed: return 'Reboxed';
        default: return 'Unknown action';
    }
}
